import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import {cloneDeep} from 'lodash'
import filter from './modules/filter'

Vue.use(Vuex)
const store = new Vuex.Store({
    namespace:true,
    state:{
        /**
         * DepartName: ""
         * UserCode: ""
         * UserId: ""
         * UserName: ""
         */
        user:null,
        //长者数组
        ElderlyCares:[],
        //当日长者执行项目
        Items:[],
        //护理历史 近3天
        NurseSignatureViews:[],
        //更新数据开关
        updateSwitch:1,
        //是否需要更新护理数据
        isNeedNursing:true,

        //上次刷卡登录的卡id
        cardId:'',

        awaitElderlyCares:[],
        awaitItems:[],
        awaitNurseSignatureViews:[],
        filterscreenLoading:false,
        saveVal:0,

        isFullScreen:false,
        isThree:false,
        isFlat:true,
        timerCode:null,
        timer:null,
        time:10000,
        scanCode:'',
        isScanCode:false
    },
    getters: {
        user: state => {
          return state.user||JSON.parse(localStorage.getItem('user'))
        },
        isFlatThreeFullScreen: state => {
            return state.isFullScreen && state.isThree && state.isFlat
        },
        isFlatThree: state => {
            return state.isThree&&state.isFlat
        },

    },
    mutations: {
        updateCardId(state,cardId){
            state.cardId=cardId
        },
        updateFullScreen(state,isFullScreen){
            state.isFullScreen=isFullScreen
        },
        updateThree(state,isThree){
          console.log("1231231");
            state.isThree=isThree
        },
        updateFlat(state,isFlat){
            state.isFlat=isFlat
        },
        //进入老者页执行一次，关闭左侧筛选完成执行一次（打开时先会清除计时器），在老者页面非筛选框触屏时执行一次，【老者页面关闭时清除计时器】
        resetTime(state){
            if(state.isFlat&&state.isThree){
                if(state.timer){
                    clearTimeout(state.timer)
                }
                state.timer=setTimeout(()=>{
                    if(state.isFlat&&state.isThree){
                        state.isFullScreen=true
                    }
                },state.time)
            }
        },
        //更新用户信息
        updatedUser (state, user) {
            localStorage.setItem('user',JSON.stringify(user))
            state.user=user
        },
        //设置护理请求开关
        setNursingSwitch(state,val){
            state.isNeedNursing=val
        },
        //更新护理数据
        updateNursing(state, {ElderlyCares,Items,NurseSignatureViews}){
            state.isNeedNursing=false
            state.ElderlyCares=ElderlyCares
            state.Items=Items
            state.NurseSignatureViews=NurseSignatureViews
        },
        updateSave(state){
            state.saveVal++
        },
        // 1.是否开启扫码才能执行
        setIsScanCode(state,val){
            state.isScanCode = val
        },
        // 2.设置是否通过扫码进去护理人员的id,用来前端控制是否可以操作长者
        setScanCode(state,val){
            //清除定时器
            if (state.timerCode) {
                clearTimeout(state.timerCode)
                state.timerCode = null
            }
            //有值，设置扫码失效
            if(val){
                let timerCode = setTimeout(() => {
                    state.scanCode = ''
                },5*60*1000);
                state.timerCode = timerCode
            }
            state.scanCode = val
        },
        // 退出登录，此处逻辑不完善，暂时只是让用户退出登录
        loginOut(state){
          localStorage.removeItem('user')
          state.user = null
        }


    },
    actions: {
         //获取护理数据
         getNursingInformation({state,getters,commit}){
            state.filterscreenLoading=true
            return axios.post('/Pad/NursingInformation/NursingInformation', {
                ElderlyList:true,
                NursingHistoryPlan:true,
                UserId:getters.user.UserId
            })
            .then((res)=>{
                state.filterscreenLoading=false
                let obj=res.data.obj
                obj.Items.map(item=>{
                    // item.timestamp=new Date(item.DTime).getTime()
                    item.newDTime=item.DTime.substr(0,item.DTime.length-3).replace('T',' ')
                    item.newInputDate=item.InputDate?item.InputDate.substr(0,item.InputDate.length-3):item.InputDate
                    //缓存后续可能更改的值方便还原
                    item.oldStatus=item.Status
                    item.oldValue=item.Value
                    item.oldRemark=item.Remark
                    item.oldModels=cloneDeep(item.Models)
                })
                commit('updateNursing',obj)
            })
            .catch(err=>{
                state.filterscreenLoading=false
            })
        },
         //同步护理数据
        updateNursingInformation({state,getters,dispatch},{ElderlyCares,Items,NurseSignatureViews}){
            state.filterscreenLoading=true

          axios.post(`/Pad/NursingEditInformation?cUser=${getters.user.UserName}&cUserId=${getters.user.UserId}`, {
                ElderlyCares:ElderlyCares||state.awaitElderlyCares,
                Items:Items||state.awaitItems,
                NurseSignatureViews:NurseSignatureViews||state.awaitNurseSignatureViews
            })
            .then((res)=>{
                dispatch('getNursingInformation')
            })
            .catch(err=>{
                state.filterscreenLoading=false
            })
        },
        // 获取当前机构的系统参数配置
        getSystemData({ commit }){
            axios.get(`/Pad/GetHYPara?code=IsNecessaryToScan`)
                .then((res) => {
                    commit('setIsScanCode', res.data.obj.Value === '1')
                })
                .catch(err => {
                    state.filterscreenLoading = false
                })
        }

    },
    modules: {
        filter
    }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js